import { ThemeToggle } from '@/components/ui/theme-toggle'
import { UserMenu } from './user-menu'
import { OrgSwitcher } from './org-switcher'

export function HeaderBar() {
  return (
    <header className="flex h-16 items-center justify-between gap-4 border-b border-border bg-bg-surface px-8">
      <div className="hidden font-mono text-xs uppercase tracking-wider text-fg-muted md:block">
        Operación · Panel administrativo
      </div>
      <div className="flex items-center gap-3">
        <OrgSwitcher />
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  )
}
